import type { UpstreamSource } from '../types/gateway';

/**
 * DDD #180 S1.2 — central panel → upstream-source binding.
 *
 * usePanelState(panelKey, PANEL_SOURCE[panelKey]) lets a panel escalate a
 * 200-empty to 'degraded' when its upstream is reported down (fail-open case).
 *
 * AUTHORITATIVE — bound from Delta-A's gateway route trace (PR #149). Final
 * binding is a ONE-LINE edit here — zero component changes.
 *
 * undefined → no upstream_health bit maps (e.g. jobs=AzureML, unwired).
 * usePanelState then relies on the client-side fetch outcome (panelStatus)
 * only — never marks degraded via upstream_health. Keep that path solid.
 */
export const PANEL_SOURCE: Record<string, UpstreamSource | undefined> = {
  risk: 'redis',
  portfolio: 'redis',
  equity: 'redis',
  varcone: 'clickhouse',
  regime: 'regime',
  chart: 'clickhouse', // get_bars → clickhouse
  combo: 'redis', // get_combo_status / genome / alpha_eval → redis
  signals: 'redis', // get_signals → redis
  trades: 'redis', // renders signals → redis
  actionboard: 'redis', // renders signals → redis
  account: 'bybit', // bybit:positions:summary via BybitRedisAdapter → bybit
  // jobs → undefined (AzureML · no upstream_health bit · client-outcome only)
};
